import { render, staticRenderFns } from "./FilterCatalogLevel1.vue?vue&type=template&id=84f10a16&"
import script from "./FilterCatalogLevel1.vue?vue&type=script&lang=js&"
export * from "./FilterCatalogLevel1.vue?vue&type=script&lang=js&"
import style0 from "./FilterCatalogLevel1.vue?vue&type=style&index=0&id=84f10a16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports